'use client'

import Link from 'next/link'
import { useState } from 'react'
import { usePathname } from 'next/navigation'

const DefaultHeader = ({ transparent, extraClass }) => {
  const [toggle, setToggle] = useState(false)
  const currentUrl = usePathname()
  const closeMenu = () => {
    setToggle(false)
  }

  return (
    <div className={`mil-top-position mil-fixed ${extraClass || ''}`}>
      <div
        className={`mil-top-panel ${transparent ? 'mil-top-panel-transparent mil-animated' : ''}`}
      >
        {/* mil-top-panel-transparent */}
        <div className="container">
          <Link href="/" legacyBehavior>
            <a
              className="mil-logo"
              style={{ width: 180 }}
              aria-label="Pyther Innovations Home"
              href="/"
            ></a>
          </Link>
          <div className={`mil-navigation ${toggle ? 'mil-active' : ''}`}>
            <nav>
              <ul style={{ letterSpacing: 1, lineHeight: 1 }}>
                <li>
                  <Link
                    href="/"
                    className={`${currentUrl === '/' ? 'activ-color' : ''}`}
                    onClick={closeMenu}
                  >
                    HOME
                  </Link>
                </li>
                <li>
                  <Link
                    href="/portfolio"
                    className={`${currentUrl === '/portfolio' ? 'activ-color' : ''}`}
                    onClick={closeMenu}
                  >
                    PORTFOLIO
                  </Link>
                </li>
                <li>
                  <Link
                    href="/services"
                    className={`${currentUrl === '/services' ? 'activ-color' : ''}`}
                    onClick={closeMenu}
                  >
                    SERVICES
                  </Link>
                </li>
                <li>
                  <Link
                    href="/vision-ai"
                    className={currentUrl === '/vision-ai' ? 'activ-color' : ''}
                    onClick={closeMenu}
                  >
                    VISION AI
                  </Link>
                </li>

                <li>
                  <Link
                    href="/career"
                    className={`${currentUrl === '/career' ? 'activ-color' : ''}`}
                    onClick={closeMenu}
                  >
                    CAREER
                  </Link>
                </li>
                <li>
                  <Link
                    href="/team"
                    className={`${currentUrl === '/team' ? 'activ-color' : ''}`}
                    onClick={closeMenu}
                  >
                    TEAM
                  </Link>
                </li>
                <li>
                  <Link
                    href="/about-us"
                    className={`${currentUrl === '/about-us' ? 'activ-color' : ''}`}
                    onClick={closeMenu}
                  >
                    ABOUT US
                  </Link>
                </li>
                <li>
                  <Link
                    href="/contact-us"
                    className={`${currentUrl === '/contact-us' ? 'activ-color' : ''}`}
                    onClick={closeMenu}
                  >
                    CONTACT US
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
          {/* mobile menu button */}
          <div
            className={`mil-menu-btn ${toggle ? 'mil-active' : ''}`}
            onClick={() => setToggle(!toggle)}
          >
            <span />
          </div>
          {/* mobile menu button end */}
        </div>
      </div>
    </div>
  )
}
export default DefaultHeader
